import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './interview.reducer';

export const InterviewDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const interviewEntity = useAppSelector(state => state.interview.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="interviewDetailsHeading">
          <Translate contentKey="fivePlusApp.interview.detail.title">Interview</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{interviewEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fivePlusApp.interview.name">Name</Translate>
            </span>
          </dt>
          <dd>{interviewEntity.name}</dd>
          <dt>
            <span id="interviewTime">
              <Translate contentKey="fivePlusApp.interview.interviewTime">Interview Time</Translate>
            </span>
          </dt>
          <dd>{interviewEntity.interviewTime}</dd>
          <dt>
            <span id="duration">
              <Translate contentKey="fivePlusApp.interview.duration">Duration</Translate>
            </span>
          </dt>
          <dd>{interviewEntity.duration}</dd>
          <dt>
            <span id="statusType">
              <Translate contentKey="fivePlusApp.interview.statusType">Status Type</Translate>
            </span>
          </dt>
          <dd>{interviewEntity.statusType}</dd>
          <dt>
            <span id="dailyCoLink">
              <Translate contentKey="fivePlusApp.interview.dailyCoLink">Daily Co Link</Translate>
            </span>
          </dt>
          <dd>{interviewEntity.dailyCoLink}</dd>
          <dt>
            <span id="daliyCoRoom">
              <Translate contentKey="fivePlusApp.interview.daliyCoRoom">Daliy Co Room</Translate>
            </span>
          </dt>
          <dd>{interviewEntity.daliyCoRoom}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.interview.user">User</Translate>
          </dt>
          <dd>{interviewEntity.user ? interviewEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/interview" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/interview/${interviewEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InterviewDetail;
